import { InfoTag, UploaderInfoElement, UploaderName, VideoTitle } from './Styled'

interface PromotionInfoProps {
  promoter?: string
  description?: string
  link?: string
  [key: string]: any
}

const PromotionInfo = ({ promoter = '', description = '', link = '', ...props }: PromotionInfoProps) => {
  return (
    <UploaderInfoElement {...props}>
      <UploaderName href={link} target="_blank">
        {promoter}
        <InfoTag>查看详情</InfoTag>
      </UploaderName>
      <VideoTitle>{description}</VideoTitle>
    </UploaderInfoElement>
  )
}

export default PromotionInfo
